import { createLink, LinkComponent } from '@tanstack/react-router';

const newTabParams = {
  target: '_blank',
};

type BasicLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  ref?: React.RefObject<HTMLAnchorElement>;
  inNewTab?: boolean;
};

export const BasicLinkComponent = ({ ref, inNewTab = false, ...props }: BasicLinkProps) => {
  const newTabProps = inNewTab ? newTabParams : {};

  return <a ref={ref} {...props} {...newTabProps} />;
};

const CreatedLinkComponent = createLink(BasicLinkComponent);

export const Link: LinkComponent<typeof BasicLinkComponent> = (props) => {
  return <CreatedLinkComponent {...props} />;
};
